import React from 'react';
import { IconPropTypes } from 'ggApp/types/propTypes';

const ForYouFilledIcon = ({ color, size, className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5877 13.6268C20.6092 17.9471 15.4159 21.6307 11.119 21.9803C9.56038 22.1014 8.04671 21.6424 6.72054 20.8338C6.00179 20.3963 5.33773 19.8534 4.75374 19.246C3.02523 17.5838 1.83187 15.285 2.01937 12.8807C2.3846 8.33775 5.80062 3.44908 10.3748 2.41393C13.2889 1.744 17.6405 1.66783 20.0311 3.95885C22.3201 6.35533 22.2557 10.7069 21.5877 13.6268ZM16.701 11.6971C16.701 14.1288 14.7342 16.0956 12.3026 16.0956C9.87679 16.0956 7.90609 14.1288 7.90609 11.6971C7.90609 9.2733 9.87484 7.30065 12.3026 7.30065C13.6424 7.30065 14.8416 7.90025 15.6483 8.84361C16.3045 9.61119 16.701 10.6092 16.701 11.6971Z"
            fill={color}
        />
    </svg>
);

ForYouFilledIcon.propTypes = {
    ...IconPropTypes,
};

ForYouFilledIcon.defaultProps = {
    className: '',
    color: '#333333',
    size: '24px',
};

export default ForYouFilledIcon;
